import { has } from "lodash";
import { AnswersMap, QuestionType } from "../types";

export default function areQuestionsComplete(
  questions: QuestionType[],
  answers: AnswersMap
): boolean {
  return questions.every(({ index }) => has(answers, [index, "score"]));
}
